var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-xs"},[_vm._v("\n    "+_vm._s(_vm.trans.get('wizard.newsletter.privacy_policy_01'))+" \n    "),_c('a',{staticClass:"underline",attrs:{"href":'/' + _vm.lang + '/legal/' + _vm.privacyPolicyUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.trans.get('wizard.newsletter.privacy_policy_02')))]),_vm._v(".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }